<template>
  <a-drawer width="55%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" labelAlign="left" :model="form"  :rules="rules">
      <a-row>
        <a-col :span="24">
          <a-form-model-item prop="couponName" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
            <span slot="label" >
              <a-tooltip>
                优惠券名称<template slot="title">优惠券名称</template>
              </a-tooltip>
            </span>
            <a-input v-model="form.couponName" style="width: 70%" :maxLength="20" :placeholder="$t('请输入')+'优惠券名称'" >
              <locale-field-button
                slot="suffix"
                class="ant-input-suffix-button"
                v-model="form.localeFieldMap['couponName']"
                input-type="input"
                table-name="activity_coupon"
                table-field="couponName"
                :field-value="form.couponName"/>
            </a-input>
          </a-form-model-item>
        </a-col>
        <a-col :span="24" v-if="false">
          <a-form-model-item prop="couponType" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
            <span slot="label" >
              <a-tooltip>
                优惠券类型<template slot="title">类型 1:满减券 2:满减配送费券 3:代金券(可售)</template>
              </a-tooltip>
            </span>
            <a-radio-group v-model="form.couponType" button-style="solid">
              <a-radio-button v-for="(item, index) in this.customDict.CouponTypeEnum" :value="item.type" :key="index">
                {{ item.name }}
              </a-radio-button>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item prop="getWay"  :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
            <span slot="label" >
              <a-tooltip>
                获取方式<template slot="title">获取方式 1客户领取 2:平台发放 3:购买 4:下单返券</template>
              </a-tooltip>
            </span>
            <a-radio-group v-model="form.getWay" button-style="solid" @change="getWayChange">
              <a-radio-button v-for="(item, index) in this.customDict.CouponGetWayEnum" :value="item.type" :key="index">
                {{ item.name }}
              </a-radio-button>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="12">
          <a-form-model-item prop="merchantScope" :label-col="{span: 6}" :wrapper-col="{span: 16}">
            <span slot="label" >
              <a-tooltip>
                商家选择<template slot="title">不选择,默认全部商家参与</template>
              </a-tooltip>
            </span>
            <a-radio-group v-model="form.merchantScope" button-style="solid">
              <a-radio-button v-for="(item, index) in this.customDict.CouponMerchantScopeEnum" :value="item.type" :key="index">
                {{ item.name }}
              </a-radio-button>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :span="12" v-if="form.merchantScope===2">
          <a-form-model-item prop="merchantList"  :label-col="{span: 6}" :wrapper-col="{span: 16}">
            <a-button type="dashed"  v-if="form.merchantList!=null && form.merchantList.length > 0" style="text-align: left; width: 100%" @click="openMerchantSelect" danger>
              <span style="color: dodgerblue">已选择{{form.merchantList.length}}家商家</span>
            </a-button>
            <a-button v-else plain type="primary" @click="openMerchantSelect">选择商家</a-button>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="24">
          <a-form-model-item prop="limitMemberList" :label-col="{span: 3}" :wrapper-col="{span: 20}">
            <span slot="label" >
              <a-tooltip>
                限制会员等级<template slot="title">限制会员等级</template>
              </a-tooltip>
            </span>
            <a-select placeholder="请选择限制会员等级" style="width: 100%" v-model="form.limitMemberList" mode="multiple" allowClear>
              <a-select-option v-for="(item, index) in levelList" :value="item.id" :key="index">
                {{ item.levelName }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="12">
          <a-form-model-item prop="cashCondition" :label-col="{span: 6}" :wrapper-col="{span: 16}">
            <span slot="label" >
              <a-tooltip>
                使用条件<template slot="title">使用条件</template>
              </a-tooltip>
            </span>
            <a-input v-model="form.cashCondition" oninput="value=value.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/, '$1')"  :placeholder="$t('请输入')+'使用条件'" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item prop="reduceAmount"  :label-col="{span: 6}" :wrapper-col="{span: 16}">
            <span slot="label" >
              <a-tooltip>
                减免金额<template slot="title">减免金额</template>
              </a-tooltip>
            </span>
            <a-input v-model="form.reduceAmount" oninput="value=value.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/, '$1')" :placeholder="$t('请输入')+'减免金额'" />
          </a-form-model-item>
        </a-col>
      </a-row>
<!--      <a-form-model-item prop="couponImg" >
        <span slot="label" >
          <a-tooltip>
            优惠券封面<template slot="title">优惠券封面</template>
          </a-tooltip>
        </span>
        <oss-upload-single v-model="form.couponImg" prefix="coupon" type="img"/>
      </a-form-model-item>-->

      <a-row>
        <a-col :span="12">
          <a-form-model-item prop="startTime"  :label-col="{span: 6}" :wrapper-col="{span: 16}">
            <span slot="label" >
              <a-tooltip>
                领取开始时间<template slot="title">领取开始时间</template>
              </a-tooltip>
            </span>
            <a-date-picker style="width: 100%" v-model="form.startTime" :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}" format="YYYY-MM-DD HH:mm:ss" valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item prop="endTime"  :label-col="{span: 6}" :wrapper-col="{span: 16}">
            <span slot="label" >
              <a-tooltip>
                领取结束时间<template slot="title">领取结束时间</template>
              </a-tooltip>
            </span>
            <a-date-picker style="width: 100%" v-model="form.endTime"  :show-time="{defaultValue: moment('23:59:59', 'HH:mm:ss')}" format="YYYY-MM-DD HH:mm:ss" valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col  :span="24">
          <a-form-model-item prop="receiveTimeType"  :label-col="{span: 3}" :wrapper-col="{span: 16}">
            <span slot="label" >
              领取时间段
              <a-tooltip><template slot="title">领取结束时间</template></a-tooltip>
            </span>
            <a-radio-group v-model="form.receiveTimeType">
              <a-radio v-for="(item, index) in this.customDict.ActivityTimeTypeEnum" :value="item.type" :key="index">
                {{ item.name }}
              </a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :span="24" v-if="form.receiveTimeType===2 " style="padding-left: 50px;">
          <a-card v-for="(activityTime, index) in form.receiveEffectiveTimeList" :key="index" style="width: 50%">
            每天<a-time-picker v-model="activityTime.startTime" format="HH:mm" valueFormat="HH:mm" />-
            <a-time-picker v-model="activityTime.endTime" format="HH:mm" valueFormat="HH:mm" />
            <a-button type="link" style="color: red"  @click="delReceiveTimeRange(index)"><a-icon type="delete" />删除</a-button>
          </a-card>
          <div style="width: 50%">
            <a-button type="link"  @click="addReceiveTimeRange"><a-icon type="plus" />添加时段</a-button>
          </div>
        </a-col>
        <a-col :span="24" v-if="form.receiveTimeType===3 " style="padding-left: 20px;">
          <a-card v-for="(activityTime, index) in form.receiveEffectiveTimeList" :key="index" >
            <a-select  mode="multiple" placeholder="请选择周" style="width: 55%" v-model="activityTime.dayOfWeekList" allowClear>
              <a-select-option v-for="(item, index) in customDict.DayOfWeekEnum" :value="item.type" :key="index">{{ item.name }}</a-select-option>
            </a-select>
            <a-time-picker v-model="activityTime.startTime" format="HH:mm" valueFormat="HH:mm" />-
            <a-time-picker v-model="activityTime.endTime" format="HH:mm" valueFormat="HH:mm"/>
            <a-button type="link" style="color: red"  @click="delReceiveTimeRange(index)"><a-icon type="delete" />删除</a-button>
          </a-card>
          <div>
            <a-button type="link"  @click="addReceiveTimeRange"><a-icon type="plus" />添加时段</a-button>
          </div>
        </a-col>
        <a-col :span="24" v-if="form.receiveTimeType===4 " style="padding-left: 20px;">
          <a-card v-for="(activityTime, index) in form.receiveEffectiveTimeList" :key="index" >
            <a-select  mode="multiple" placeholder="请选择月" style="width: 55%" v-model="activityTime.monthOfYearList" allowClear>
              <a-select-option v-for="(item, index) in customDict.MonthOfYearEnum" :value="item.type" :key="index">{{ item.name }}</a-select-option>
            </a-select>
            <a-time-picker v-model="activityTime.startTime" format="HH:mm" valueFormat="HH:mm" />-
            <a-time-picker v-model="activityTime.endTime" format="HH:mm" valueFormat="HH:mm"/>
            <a-button type="link" style="color: red"  @click="delReceiveTimeRange(index)"><a-icon type="delete" />删除</a-button>
          </a-card>
          <div>
            <a-button type="link"  @click="addReceiveTimeRange"><a-icon type="plus" />添加时段</a-button>
          </div>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="12">
          <a-form-model-item prop="useStartTime"  :label-col="{span: 6}" :wrapper-col="{span: 16}">
            <span slot="label" >
              <a-tooltip>
                使用开始时间<template slot="title">使用开始时间</template>
              </a-tooltip>
            </span>
            <a-date-picker style="width: 100%" v-model="form.useStartTime" :disabled="formType === 2"  :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}" format="YYYY-MM-DD HH:mm:ss" valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item prop="useEndTime"  :label-col="{span: 6}" :wrapper-col="{span: 16}">
            <span slot="label" >
              <a-tooltip>
                使用结束时间<template slot="title">使用结束时间</template>
              </a-tooltip>
            </span>
            <a-date-picker style="width: 100%" v-model="form.useEndTime" :disabled="formType === 2" :show-time="{defaultValue: moment('23:59:59', 'HH:mm:ss')}" format="YYYY-MM-DD HH:mm:ss" valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col  :span="24">
          <a-form-model-item prop="useTimeType"  :label-col="{span: 3}" :wrapper-col="{span: 16}">
            <span slot="label" >
              使用时间段
              <a-tooltip><template slot="title">使用时间段</template></a-tooltip>
            </span>
            <a-radio-group v-model="form.useTimeType" :disabled="formType===2">
              <a-radio v-for="(item, index) in this.customDict.ActivityTimeTypeEnum" :value="item.type" :key="index">
                {{ item.name }}
              </a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :span="24" v-if="form.useTimeType===2 " style="padding-left: 50px;">
          <a-card v-for="(activityTime, index) in form.useEffectiveTimeList" :key="index" style="width: 50%">
            每天<a-time-picker v-model="activityTime.startTime" format="HH:mm" valueFormat="HH:mm" />-
            <a-time-picker v-model="activityTime.endTime" format="HH:mm" valueFormat="HH:mm" />
            <a-button type="link" v-if="formType===1" style="color: red"  @click="delUseTimeRange(index)"><a-icon type="delete" />删除</a-button>
          </a-card>
          <div style="width: 50%">
            <a-button type="link" v-if="formType===1" @click="addUseTimeRange"><a-icon type="plus" />添加时段</a-button>
          </div>
        </a-col>
        <a-col :span="24" v-if="form.useTimeType===3 " style="padding-left: 20px;">
          <a-card v-for="(activityTime, index) in form.useEffectiveTimeList" :key="index" >
            <a-select mode="multiple" placeholder="请选择周" style="width: 55%" v-model="activityTime.dayOfWeekList" allowClear>
              <a-select-option v-for="(item, index) in customDict.DayOfWeekEnum" :value="item.type" :key="index">{{ item.name }}</a-select-option>
            </a-select>
            <a-time-picker v-model="activityTime.startTime" format="HH:mm" valueFormat="HH:mm" />-
            <a-time-picker v-model="activityTime.endTime" format="HH:mm" valueFormat="HH:mm"/>
            <a-button type="link" v-if="formType===1" style="color: red"  @click="delUseTimeRange(index)"><a-icon type="delete" />删除</a-button>
          </a-card>
          <div>
            <a-button type="link" v-if="formType===1" @click="addUseTimeRange"><a-icon type="plus" />添加时段</a-button>
          </div>
        </a-col>
        <a-col :span="24" v-if="form.useTimeType===4 " style="padding-left: 20px;">
          <a-card v-for="(activityTime, index) in form.useEffectiveTimeList" :key="index" >
            <a-select  mode="multiple" placeholder="请选择月" style="width: 55%" v-model="activityTime.monthOfYearList" allowClear>
              <a-select-option v-for="(item, index) in customDict.MonthOfYearEnum" :value="item.type" :key="index">{{ item.name }}</a-select-option>
            </a-select>
            <a-time-picker v-model="activityTime.startTime" format="HH:mm" valueFormat="HH:mm" />-
            <a-time-picker v-model="activityTime.endTime" format="HH:mm" valueFormat="HH:mm"/>
            <a-button type="link" v-if="formType===1" style="color: red"  @click="delUseTimeRange(index)"><a-icon type="delete" />删除</a-button>
          </a-card>
          <div>
            <a-button type="link" v-if="formType===1" @click="addUseTimeRange"><a-icon type="plus" />添加时段</a-button>
          </div>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="12">
          <a-form-model-item prop="stock"  :label-col="{span: 6}" :wrapper-col="{span: 16}">
            <span slot="label" >
              <a-tooltip>
                库存<template slot="title">库存</template>
              </a-tooltip>
            </span>
            <a-input v-model="form.stock"  oninput="value=value.replace(/[^\d]/g,'')" :placeholder="$t('请输入')+'库存'" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item prop="limitNum"  :label-col="{span: 6}" :wrapper-col="{span: 16}">
            <span slot="label" >
              <a-tooltip>
                单用户领券上限<template slot="title">每个用户领券上限</template>
              </a-tooltip>
            </span>
            <a-input v-model="form.limitNum" oninput="value=value.replace(/[^\d]/g,'')"  :placeholder="$t('请输入')+'每个用户领券上限'" />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row v-if="form.couponType === 3">
        <a-col :span="12">
          <a-form-model-item prop="saleAmount"  :label-col="{span: 6}" :wrapper-col="{span: 16}">
            <span slot="label" >
              <a-tooltip>
                售卖金额<template slot="title">售卖金额(优惠券类型为代金券使用)</template>
              </a-tooltip>
            </span>
            <a-input v-model="form.saleAmount"  oninput="value=value.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/, '$1')" :placeholder="$t('请输入')+'售卖金额(优惠券类型为代金券使用)'" />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="12">
          <a-form-model-item prop="suitableType"  :label-col="{span: 6}" :wrapper-col="{span: 16}">
            <span slot="label" >
              <a-tooltip>
                适用商品类型<template slot="title">适用商品类型 0全部商品参与 1指定商品参与</template>
              </a-tooltip>
            </span>
            <a-radio-group v-model="form.suitableType" button-style="solid">
              <a-radio-button v-for="(item, index) in this.customDict.CouponSuitableTypeEnum" :value="item.type" :key="index">
                {{ item.name }}
              </a-radio-button>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :span="12" v-if="form.suitableType===2">
          <a-form-model-item prop="merchantList"  :label-col="{span: 6}" :wrapper-col="{span: 16}">
            <a-button type="dashed"  v-if="form.goodsList!=null && form.goodsList.length > 0" style="text-align: left; width: 100%" @click="openGoodsSelect" danger>
              <span style="color: dodgerblue">已选择{{form.goodsList.length}}件商品</span>
            </a-button>
            <a-button v-else plain type="primary" @click="openGoodsSelect">选择商品</a-button>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="24">
          <a-form-model-item prop="isPopup"  :label-col="{span: 3}" :wrapper-col="{span: 16}">
            <span slot="label" >
              <a-tooltip>
                是否弹窗<template slot="title">优惠券将在APP首页弹窗展示</template>
              </a-tooltip>
            </span>
            <a-radio-group v-model="form.isPopup" button-style="solid">
              <a-radio-button v-for="(item, index) in this.customDict.TFEnum" :value="item.type" :key="index">
                {{ item.name }}
              </a-radio-button>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item prop="couponStatus"  :label-col="{span: 3}" :wrapper-col="{span: 16}">
            <span slot="label" >
              <a-tooltip>
                上架状态<template slot="title">1:投放 0:下架)</template>
              </a-tooltip>
            </span>
            <a-radio-group v-model="form.couponStatus" button-style="solid">
              <a-radio-button v-for="(item, index) in this.customDict.CouponStatusEnum" :value="item.type" :key="index">
                {{ item.name }}
              </a-radio-button>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item prop="bundledCount"  :label-col="{span: 3}" :wrapper-col="{span: 16}">
            <span slot="label" >
              <a-tooltip>
                捆绑数量<template slot="title">用户领一次,相当于有对应数量的券入卡包</template>
              </a-tooltip>
            </span>
            <a-input v-model="form.bundledCount"  oninput="value=value.replace(/[^\d]/g,'')" :placeholder="$t('请输入')+'捆绑数量'" />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="24"  v-if="false">
          <a-form-model-item prop="mutexType" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
            <span slot="label" >
              <a-tooltip>
                叠加类型<template slot="title">叠加类型 0不叠加 1不同类型叠加, 例如可同时使用满减券和配送券</template>
              </a-tooltip>
            </span>
            <a-radio-group v-model="form.mutexType" button-style="solid">
              <a-radio-button v-for="(item, index) in this.customDict.CouponMutexTypeEnum" :value="item.type" :key="index">
                {{ item.name }}
              </a-radio-button>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
      </a-row>
<!--      <a-row>
        <a-col :span="12">
          <a-form-model-item prop="sameMutex" v-if="form.mutexType === 1 || form.mutexType === 2"  :label-col="{span: 6}" :wrapper-col="{span: 16}">
            <span slot="label" >
              <a-tooltip>
                同类型是否叠加<template slot="title">同类型是否叠加 1 叠加 0 不叠加</template>
              </a-tooltip>
            </span>
            <a-radio-group v-model="form.sameMutex" button-style="solid"  :disabled="form.differentMutex===1"  @change="checkMutex">
              <a-radio-button v-for="(item, index) in this.customDict.CouponSameMutexTypeEnum" :value="item.type" :key="index">
                {{ item.name }}
              </a-radio-button>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item prop="differentMutex" v-if="form.mutexType === 1 || form.mutexType === 2"   :label-col="{span: 6}" :wrapper-col="{span: 16}">
            <span slot="label" >
              <a-tooltip>
                不同类型是否叠加<template slot="title">不同类型是否叠加 1 叠加 0 不叠加</template>
              </a-tooltip>
            </span>
            <a-radio-group v-model="form.differentMutex" button-style="solid" :disabled="form.sameMutex===1" @change="checkMutex">
              <a-radio-button v-for="(item, index) in this.customDict.CouponSameMutexTypeEnum" :value="item.type" :key="index">
                {{ item.name }}
              </a-radio-button>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
      </a-row>-->
      <a-row>
        <a-col :span="24">
          <a-form-model-item prop="couponDesc" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
            <span slot="label" >
              <a-tooltip>
                描述详情<template slot="title">描述详情</template>
              </a-tooltip>
            </span>
            <a-input v-model="form.couponDesc" :placeholder="$t('请输入')" type="textarea" allow-clear />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="24">
          <a-form-model-item prop="buyDesc" v-if="form.couponType === 3" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
            <span slot="label" >
              <a-tooltip>
                购买须知<template slot="title">购买须知</template>
              </a-tooltip>
            </span>
            <a-input v-model="form.buyDesc" :placeholder="$t('请输入')" type="textarea" allow-clear />
          </a-form-model-item>
        </a-col>
      </a-row>

<!--      <a-form-model-item prop="levelCondition" >
        <span slot="label" >
          <a-tooltip>
            会员领取的等级限制<template slot="title">会员领取的等级限制</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.levelCondition" :maxLength="200" :placeholder="$t('请输入')+'会员领取的等级限制'" />
      </a-form-model-item>-->
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
    <merchant-select ref="merchantSelect" @merchantSelected="handleMerchantSelected"></merchant-select>
    <goods-checkbox-select ref="goodsSelect" @goodsSelect="handleGoodsSelected"></goods-checkbox-select>
  </a-drawer>
</template>

<script>
import { getCoupon, addCoupon, updateCoupon } from '@/api/activity/coupon'
import {mapGetters} from 'vuex'
import moment from 'moment';
import CustomDictTag from "@/components/DictCustomTag";
import {generateFilePath, uploadObject} from "@/api/tool/oss";
import OssUploadSingle from "@/components/OssUploadSingle/index.vue";
import MerchantSelect from "@/views/merchant/merchant/select/merchantSelect.vue";
import GoodsCheckboxSelect from "@/views/goods/goods/select/GoodsCheckboxSelect.vue";
import LocaleFieldButton from "@/components/locale/LocaleFieldButton.vue";

export default {
  name: 'CreateForm',
  props: {
    levelList:{
      require: true,
      type: Array
    }
  },
  components: {
    LocaleFieldButton,
    OssUploadSingle,
    CustomDictTag,
    MerchantSelect,
    GoodsCheckboxSelect
  },
  data () {
    return {
      moment,
      labelCol: { span: 4 },
      wrapperCol: { span: 16 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
        id: null,
        merchantId: null,
        merchantList:[],
        goodsList:[],
        limitMemberList: [],
        merchantScope: 1,
        couponName: null,
        couponType: 1,
        couponImg: null,
        cashCondition: 0,
        reduceAmount: 0.01,
        startTime: moment().format('YYYY-MM-DD HH:mm:ss'),
        endTime: null,
        receiveTimeType: 1,
        receiveEffectiveTimeList: [],
        useStartTime: moment().format('YYYY-MM-DD HH:mm:ss'),
        useEndTime: null,
        useTimeType: 1,
        useEffectiveTimeList: [],
        stock: 1,
        suitableType: 1,
        limitNum: 1,
        couponStatus: true,
        bundledCount: 1,
        saleAmount: 0,
        getWay: 1,
        levelCondition: null,
        couponDesc: null,
        buyDesc: null,
        mutexType: 0,
        differentMutex: 0,
        sameMutex: 0,
        isCanRefund: null,
        isPopup: false,
        remark: null,
        localeFieldMap: {},
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        getWay: [{ required: true, message: '获取方式'+this.$t('不能为空'), trigger: 'change' }],
        suitableType: [{ required: true, message: '适用商品类型'+this.$t('不能为空'), trigger: 'change' }],
        startTime: [{ required: true, message: '开始时间'+this.$t('不能为空'), trigger: 'change' }],
        endTime: [{ required: true, message: '结束时间'+this.$t('不能为空'), trigger: 'change' }],
        receiveTimeType: [{ required: true, message: '领取时间段'+this.$t('不能为空'), trigger: 'change' }],
        useStartTime: [{ required: true, message: '使用开始时间'+this.$t('不能为空'), trigger: 'change' }],
        useEndTime: [{ required: true, message: '使用结束时间'+this.$t('不能为空'), trigger: 'change' }],
        useTimeType: [{ required: true, message: '使用时间段'+this.$t('不能为空'), trigger: 'change' }],
        isPopup: [{ required: true, message: '是否弹窗'+this.$t('不能为空'), trigger: 'change' }],
        stock: [{ required: true, message: '库存'+this.$t('不能为空'), trigger: 'blur' }],
        saleAmount: [{ required: true, message: '满减金额'+this.$t('不能为空'), trigger: 'blur' }],
        reduceAmount: [{ required: true, message: '优惠金额'+this.$t('不能为空'), trigger: 'blur' }],
        cashCondition: [{ required: true, message: '使用条件'+this.$t('不能为空'), trigger: 'blur' }],
        limitNum: [{ required: true, message: '限制数量'+this.$t('不能为空'), trigger: 'blur' }],
        couponName: [{ required: true, message: '优惠券名称'+this.$t('不能为空'), trigger: 'blur' }],
        bundledCount: [{ required: true, message: '捆绑优惠券数量'+this.$t('不能为空'), trigger: 'blur' }],
        couponType: [{ required: true, message: '优惠券类型'+this.$t('不能为空'), trigger: 'change' }],
        couponStatus: [{ required: true, message: '优惠券状态'+this.$t('不能为空'), trigger: 'change' }],
        limitMemberList: [{ required: true, message: '限制会员等级'+this.$t('不能为空'), trigger: 'change' }],
        mutexType: [{ required: true, message: '优惠券叠加类型'+this.$t('不能为空'), trigger: 'change' }],
        merchantScope: [{ required: true, message: '商户范围类型'+this.$t('不能为空'), trigger: 'change' }],
        differentMutex: [{ required: true, message: '不同类型是否叠加 1 叠加 0 不叠加'+this.$t('不能为空'), trigger: 'blur' }],
        sameMutex: [{ required: true, message: '同类型是否叠加 1 叠加 0 不叠加'+this.$t('不能为空'), trigger: 'blur' }]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        merchantId: null,
        merchantList:[],
        goodsList:[],
        limitMemberList: [],
        merchantScope: 1,
        couponName: null,
        couponType: 1,
        couponImg: null,
        cashCondition: 0,
        reduceAmount: 0.01,
        startTime: moment().format('YYYY-MM-DD HH:mm:ss'),
        endTime: null,
        receiveTimeType: 1,
        receiveEffectiveTimeList: [],
        useStartTime: moment().format('YYYY-MM-DD HH:mm:ss'),
        useEndTime: null,
        useTimeType: 1,
        useEffectiveTimeList: [],
        stock: 1,
        suitableType: 1,
        limitNum: 1,
        couponStatus: true,
        bundledCount: 1,
        saleAmount: 0,
        getWay: 1,
        levelCondition: null,
        couponDesc: null,
        buyDesc: null,
        mutexType: 0,
        differentMutex: 0,
        sameMutex: 0,
        isCanRefund: null,
        createTime: null,
        remark: null,
        isPopup: false,
        localeFieldMap: {},
      }

    },
    getWayChange() {
      //如果是购买类型,那么couponType 变为代金券
      if (this.form.getWay===3) {
        this.form.couponType = 3
      } else {
        this.form.couponType = 1
      }
    },
    checkMutex() {
      if (this.form.differentMutex===0 && this.form.sameMutex === 0) {
        console.log('置为不叠加')
        this.form.mutexType=0
      }
    },
    openMerchantSelect() {
      this.$refs.merchantSelect.openGoods(this.form.merchantList)
    },
    handleMerchantSelected(list) {
      //深拷贝
      const cloneData = JSON.parse(JSON.stringify(list))
      this.form.merchantList = cloneData
    },

    openGoodsSelect() {
      //this.form.merchantList id 数组
      let merchantIdList = []
      if (this.form.merchantScope ===1) {
        merchantIdList = this.form.merchantList.map(item  => item.id)
      } else if (this.form.merchantScope === 3) {
        merchantIdList.push(0)
      }
      this.$refs.goodsSelect.openGoods(this.form.goodsList, merchantIdList,[20,21]);
    },
    handleGoodsSelected(list) {
      console.log('商品选择了:',list)
      this.form.goodsList = list
    },
    addReceiveTimeRange() {
      let data = {"dayOfWeekList": [], "monthOfYearList": [], "startTime": undefined, "endTime": undefined};
      if (!this.form.receiveEffectiveTimeList) {
        this.form.receiveEffectiveTimeList = []
      }
      this.form.receiveEffectiveTimeList.push(data);
    },
    delReceiveTimeRange(index) {
      this.form.receiveEffectiveTimeList.splice(index, 1)
    },

    addUseTimeRange() {
      let data = {"dayOfWeekList": [], "monthOfYearList": [], "startTime": undefined, "endTime": undefined};
      if (!this.form.useEffectiveTimeList) {
        this.form.useEffectiveTimeList = []
      }
      this.form.useEffectiveTimeList.push(data);
    },
    delUseTimeRange(index) {
      this.form.useEffectiveTimeList.splice(index, 1)
    },

    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
      //初始化会员等级
      this.initLimitMember();
    },

    initLimitMember() {
      this.form.limitMemberList = []
      this.levelList.forEach(item => {
        this.form.limitMemberList.push(item.id)
      })
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getCoupon({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateCoupon(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addCoupon(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
.ant-card-body {
  padding: 5px;
}
</style>
